import TeamDefaultThumbnail from "../images/team_default.png";
import { useRecoilState } from "recoil";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { TeamWrapper, TeamThumbnail, CloseIcon } from "./TeamChip.style";
import { useHistory, useParams } from "react-router-dom";
import { teamsIdState, teamsTermState } from "../teams/Teams.state";

const TeamChip = ({ loading, thumbnail, name, editMode, onDelete, id }) => {
  const { game_id } = useParams();
  const history = useHistory();
  const [, setTerm] = useRecoilState(teamsTermState);
  const [, setId] = useRecoilState(teamsIdState);
  return (
    <TeamWrapper loading={loading} onClick={() => {
      setTerm(name)
      setId(id)
      history.push(`/teams/organize/${game_id}`)
    }}>
      {editMode ? (
        <CloseIcon onClick={onDelete}>
          <FontAwesomeIcon icon={faTimes} />
        </CloseIcon>
      ) : (
        ""
      )}
      <TeamThumbnail
        alt="group-thumbnail"
        src={thumbnail ? thumbnail : TeamDefaultThumbnail}
      />
      <p style={{ margin: 0, fontWeight: 500 }}>{name}</p>
    </TeamWrapper>
  );
};

export default TeamChip;
